export class ContactosTecniEntity{
    constructor(
        public  CodigoEmpleado ?:number,
        public  CodigoCargo ?:number,
        public  Nombre ?:string,
        public  Apellido ?:string,
        public  Cargo ?:string,
        public  Email ?:string,
        public  Extension ?:number,
        public  Movil ?:string,
        public  CiuCod ?:number,
        public  Segmento ?:string
    ){

    }
}




// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/contactos_tecni_entity.ts